module.exports = __webpack_public_path__ + "img/haproxy.75e654cd.png";